import { useTheme } from '@chakra-ui/react';
import { CommonIcons } from '../types';

export const useIcon = (name: keyof CommonIcons) => {
  const theme = useTheme();
  return theme.icons[name];
};
